import { Typography } from '@material-ui/core'
import React from 'react'

import { Promotion } from '../../graphql/promotions'
import { formatDiscount } from '../../helpers/promotions'
import { persianRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import useStyles from './styles/PromotionsTable.styles'
import { usePromotionRowActions } from './usePromotionRowActions'

interface PromotionRowMobileProps {
  data: Promotion
  refetch: () => void
}

/**
 * Drops Provider and Updated — on a phone the name, status and discount are what identify a
 * promotion; the rest is available on the record itself.
 */
const PromotionRowMobile: React.FC<PromotionRowMobileProps> = ({
  data,
  refetch
}) => {
  const classes = useStyles()
  const { openRecord, actionsCell, confirmModal } = usePromotionRowActions(
    data,
    refetch
  )

  const isPersianName = persianRegex.test(data.name)

  return (
    <div>
      <div
        className={classes.tableRowMobile}
        role="link"
        tabIndex={0}
        onClick={openRecord}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            openRecord()
          }
        }}>
        <div className={classes.nameCell}>
          <Typography
            variant="h4"
            style={isPersianName ? { fontFamily: 'IranSans' } : undefined}>
            {data.name}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate(data.status)}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {formatDiscount(
              data.discountType,
              data.discountValue,
              data.currency
            )}
          </Typography>
        </div>
        {actionsCell}
      </div>
      {confirmModal}
    </div>
  )
}

export default PromotionRowMobile
